import { useState } from "react";
import { Globe } from "lucide-react";
import { cn } from "@shared/lib/utils";

/**
 * Le logo du site d'une source, en petit, devant son nom : on reconnaît Les
 * Echos ou le BOAMP avant d'avoir lu. Servi par `/api/favicon` (notre
 * serveur) ; sans icône exploitable, un globe gris.
 */
export function SourceFavicon({ url, size = 16, className }: { url: string; size?: number; className?: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <Globe aria-hidden="true" className={cn("flex-none text-muted-foreground", className)} style={{ width: size, height: size }} />;
  }
  return (
    <img
      alt=""
      className={cn("flex-none rounded-[3px] object-contain", className)}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
      src={`/api/favicon?url=${encodeURIComponent(url)}`}
      width={size}
    />
  );
}
